module.exports = __webpack_public_path__ + "img/PAY.78d8642b.svg";